import React from "react";

import { useProposalDocument } from "./proposalDocumentsContext";

const AdvancedOptionsToggle: React.FC = () => {
  const { advancedOptionsEnabled, setAdvancedOptionsEnabled } = useProposalDocument();

  const handleToggle = (e: React.ChangeEvent<HTMLInputElement>) => {
    setAdvancedOptionsEnabled(e.target.checked);
  };

  return (
    <div className="advanced-options-toggle">
      <div className="advanced-options-toggle__content">
        <h2>Advanced Options</h2>
        <p>Additional control over proposal copy.</p>
      </div>

      <label className="advanced-options-toggle__label">
        <div className="advanced-options-toggle__switch">
          <input
            type="checkbox"
            checked={advancedOptionsEnabled}
            onChange={handleToggle}
            aria-label="Enable advanced options"
          />
          <div className="toggle-track" />
          <div className="toggle-thumb" />
        </div>
        <span>{advancedOptionsEnabled ? "Enabled" : "Disabled"}</span>
      </label>
    </div>
  );
};

export default AdvancedOptionsToggle;
